import React, { useMemo } from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import ScrollToTop from '../common/Routing/ScrollToTop/index'
import Layout from './../Layout/'
import Login from './../Login/Login'
import PrivateRoute from './../common/Routing/PrivateRoute/index'
// import { routes } from '../../constants/routes'
import BestSchoolReport from '../containers/BestSchool'
import { useSelector } from 'react-redux'
import { getActualRoutes } from '../../utils/menuStructure'

const Routes = () => {
  
  const {reports_access, data} = useSelector(state => state.auth)
  
  const routes = useMemo(() => getActualRoutes(reports_access, data?.login), [reports_access])
  
  return (
    <BrowserRouter>
      <ScrollToTop />

      <Switch>
        <Route exact path='/reports/best_school/' component={BestSchoolReport} />

        <Layout>
          {routes.map(route => (
            <PrivateRoute exact key={route.path} {...route} />
          ))}
          <Route exact path='/auth' component={Login} />
        </Layout>
      </Switch>
    </BrowserRouter>
  )
}

export default Routes
